import axios from "axios";

let host = "https://telepathystaging-env.eba-dfwrby5m.ap-southeast-2.elasticbeanstalk.com";

if (process.env.NODE_ENV === 'production') {
    console.log("production");
    host = "https://api.telepathy.cc";
}

export const api = axios.create({
    baseURL: host + "/api/v1/",
    headers: {
        "Authorization": localStorage.getItem("token") || "",
    },
});

export const http = axios.create({
    baseURL: host,
});
